import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.brand.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.brand.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.brand.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.brand.update(id), data);
  },
  changePassword(id, password) {
    let passData = { password: password };
    return BackendAPI('put', ApiRoutes.brand.changePassword(id), passData);
  },
  frozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.brand.frozen(id), data);
  },
  validateId(id) {
    return BackendAPI('get', ApiRoutes.brand.validateId(id));
  },
};
